module.exports = __webpack_public_path__ + "bv.svg?4fbc14ad662107c170024061b40f6302";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bv.svg
// module id = 1276
// module chunks = 0